import React, { Component } from 'react';
// import style from './view.module.sass';
// import SideMenu from './SideMenu';
import { Switch, Route, Redirect } from 'react-router';
import Forms from './Assisted/forms';
import SoloForms from "./Solo/forms"
import Service from './Assisted/assistedService/List';
import SoloService from "./Solo/soloService/List"
import Bpmn from './Assisted/assistJourney/List';
import Solo from "./Solo/soloJourney/List"
import Data from './Assisted/data';
import SoloData from './Solo/data';
import { Acl } from './acl';
import { SecureVariables } from './SecureVariable/list'
import Deploy from './Assisted/deployment';
import SoloDeploy from "./Solo/deployment"
import ServiceCreate from './Assisted/assistedService/create'
import SoloServiceCreate from "./Solo/soloService/create"
import FunctionCreate from '../apps/Assisted/functions/create'
import soloFunctionCreate from "./Solo/functions/create"
import BpmnCreate from './Assisted/assistJourney/create'
import SoloCreate from './Solo/soloJourney/create'
import AgentCreate from './common/aiAgents/create'
import RedirectRoute from "../../helpers/RedirectRoute";
import { accessParam } from "../../helpers/commonFunction";


import { withRouter, RouteComponentProps } from 'react-router-dom';
// import { Http } from '../../helpers/axois';
// import * as _ from 'lodash';
import Functions from './Assisted/functions';
import SoloFunctions from "./Solo/functions"
import Configuration from './Assisted/configuration';
import SoloConfiguration from "./Solo/configuration"
import { AppState } from '../../stateManager/store';
import Dmn from "./Assisted/dmn/create"
import DmnList from "./Assisted/dmn/List"
import { SoloChatQNA, NLUBasicNLP, NLUTokens, SoloChatContent, CreateDialog } from './Solo/chat'
import { AIAgents } from "./common/aiAgents"
import { EditDialog } from './Solo/chat/pages/qna/editDialog';
import { StaticAsset } from './static-asset';
import { Internationalization } from './i18n';
import { DataModel } from './dataModel';
import { SoloJourneyProvider } from './Solo/soloJourney/create/SoloJourneyProvider';


// import AuthRoute from "../../helpers/authRoute";

interface Props extends RouteComponentProps {
    appDetails: any
}

interface State {
    versionList: any;
}

const SoloJourneyWithProvider = () => (
  <SoloJourneyProvider>
    <SoloCreate />
  </SoloJourneyProvider>
);

class View extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            versionList: []
        }
    }
    // verisonsub: any;
    // componentDidMount() {
    //    this.versionUpdate();
    // }

    // componentWillReceiveProps(props:Props) {
    //     if(props.appDetails !== this.props.appDetails) {
    //         this.versionUpdate()
    //     }
    // }

    // versionUpdate() {
    //     const params: any = this.props.match.params;
    //     this.verisonsub =  Http.get(`versions/${params.appId}`).subscribe((res: any) => {
    //         const currentVersion = _.maxBy(res, 'version_code')
    //         const reindexs = _.findIndex(res, currentVersion)
    //         res[reindexs]['currentVersion'] = true;
    //         this.setState({
    //             versionList: res
    //         })
    //     })
    // }

    render() {
        const path = this.props.location.pathname;
        const isFullHeight = (path.includes("dmn") && path.includes("create")) || path.includes("nlu") || path.includes("events") || path.includes("qna") || path.includes("content") || path.includes("ai-agents")

        const redirectRouteProps = {
            matchId: accessParam(path, 2),
            selectorFn(state: AppState) {
                return state.apps.appsList
            },
            resourceField: "appId",
            message: "The URL that you are trying to visit contains invalid appId. It may have been removed or temporarily unavailable.",
            navigateTo: "/apps/list",
            buttonText: "View all apps",
        };
        // let location = useLocation().pathname.split('/')[4];
        return (<React.Fragment>
            <div className={path.includes("ai-agents") ? "" : "row"} style={{ margin: '0px', height: isFullHeight ? "100%" : "" }}>
                {/* <div className={"row " + style.view} style={{ margin: '0px' }}> */}
                {/* <div className={style.first}>
                    <SideMenu versionList={this.state.versionList}></SideMenu>
                </div> */}
                {/* <div className={style.second}> */}
                <Switch>
                    <RedirectRoute exact path="/apps/list/:appId/solo/service/list/:serviceId/create" component={SoloServiceCreate} {...redirectRouteProps} />
                    <RedirectRoute exact path={"/apps/list/:appId/journey/solo/list/:soloId/create"} component={SoloJourneyWithProvider} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/journey/solo/list" component={Solo} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/functions/list/:funcId/create" component={soloFunctionCreate} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/service/list" component={SoloService} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/functions/list" component={SoloFunctions} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/forms" component={SoloForms} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/configuration/list" component={SoloConfiguration} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/security/secure-variables/list" component={SecureVariables} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/data/list" component={SoloData} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/deploy" component={() => this.props.appDetails && <SoloDeploy data-test-id="deploy" appDetails={this.props.appDetails} />} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/acl/list" component={Acl} {...redirectRouteProps} />
                    {/* solo chat modules */}
                    <RedirectRoute exact path="/apps/list/:appId/solo/nlu/tokens" component={NLUTokens} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/nlu/basic-nlp" component={NLUBasicNLP} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/qna/dialog/:dialogId/edit" component={EditDialog} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/qna/dialog/create" component={CreateDialog} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/qna" component={SoloChatQNA} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/events/dialog/:dialogId/edit" component={EditDialog} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/events/dialog/create" component={CreateDialog} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/events" component={SoloChatQNA} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/content" component={SoloChatContent} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/ai-agents/workFlowAgents" component={AIAgents} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/ai-agents/knowledgeBaseAgents" component={AIAgents} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/ai-agents/workFlowAgents/create" component={AgentCreate} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/solo/ai-agents/:agentId/workFlowAgents/edit" component={AgentCreate} {...redirectRouteProps} />
                    {/* === solo chat modules === */}
                    <RedirectRoute path="/apps/list/:appId/solo/static-asset" component={StaticAsset} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/i18n/list" component={Internationalization} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/solo/dataModel/list" component={DataModel} {...redirectRouteProps} />

                    <RedirectRoute path="/apps/list/:appId/assist/service/list/:serviceId/create" component={ServiceCreate} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/dmn/list" component={DmnList} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/dmn/list/:dmnId/create" component={Dmn} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/journey/assist/list/:bpmnId/create" component={BpmnCreate} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/functions/list/:funcId/create" component={FunctionCreate} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/service/list" component={Service} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/functions/list" component={Functions} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/forms" component={Forms} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/journey/assist/list" component={Bpmn} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/configuration/list" component={Configuration} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/data/list" component={Data} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/security/secure-variables/list" component={SecureVariables} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/security/acl/list" component={Acl} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/deploy" component={() => this.props.appDetails && <Deploy data-test-id="deploy" appDetails={this.props.appDetails} />} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/static-asset" component={StaticAsset} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/i18n/list" component={Internationalization} {...redirectRouteProps} />
                    <RedirectRoute path="/apps/list/:appId/assist/dataModel/list" component={DataModel} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/ai-agents/workFlowAgents" component={AIAgents} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/ai-agents/knowledgeBaseAgents" component={AIAgents} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/ai-agents/workFlowAgents/create" component={AgentCreate} {...redirectRouteProps} />
                    <RedirectRoute exact path="/apps/list/:appId/assist/ai-agents/:agentId/workFlowAgents/edit" component={AgentCreate} {...redirectRouteProps} />
                    <Route component={() => <Redirect to="/404" />} />
                </Switch>
                {/* </div> */}
            </div>
        </React.Fragment>)
    }

    // componentWillUnmount() {
    //     if(this.verisonsub) this.verisonsub.unsubscribe()
    // }

}


export default withRouter(View);
